export const businessInfo = {
    appName: 'Swag Shots',
    operatorName: 'AMIRE GROUP',
    operatorLabel: 'Parent Business',
    gstin: '19DSEPS3377D1ZE',
    constitution: 'Proprietorship',
    registeredAddress: 'Bagdia, Unnamed Road, P.S. Dhantala, Daluabari, Nadia, West Bengal 741504',
    email: 'info@swagshots.com',
    phoneDisplay: '+91 95420-06009',
    phoneHref: '+919542006009',
};

export const operatorDisclosure =
    `${businessInfo.appName} is a brand operated by ${businessInfo.operatorName}, ` +
    `a GST-registered ${businessInfo.constitution.toLowerCase()}.`;
